<app-page-header
    [showHelpIcon]="true"
    (onOpenHelpClick)="showHelp = !showHelp"
    subtitle="{{ environment.executorNamePlural }}planning">
    <div filters>
        <mat-form-field class="project-manager-filter me-3" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Projectleider</mat-label>
            <mat-select
                [value]="selectedProjectManagerSubject.value"
                (selectionChange)="onProjectManagerFilterChange($event.value)">
                <mat-option [value]="null">Alle projectleiders</mat-option>
                @for (pm of projectManagers; track pm.id) {
                    <mat-option [value]="pm.id">{{ pm.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="view-options-filter" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Weergaveopties</mat-label>
            <mat-select [value]="selectedViewOptions" (selectionChange)="onViewOptionsChange($event.value)" multiple>
                <mat-option value="hideUnplanned">Verberg ongeplande uitvoerders</mat-option>
                <mat-option value="showFullYear">Toon jaar</mat-option>
                <mat-option value="showPreviousWeeks">Toon voorgaande 5 weken</mat-option>
                <mat-option value="showProjectNumber">Toon projectnummer</mat-option>
                <mat-option value="expandAll">Uitgeklapt</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <ng-container menu-filters>
        <div>Projectleider</div>

        <button [matMenuTriggerFor]="pmMenu" mat-button>
            {{
                selectedProjectManagerId === null
                    ? 'Alle projectleiders'
                    : (projectManagers | pmName: selectedProjectManagerId)
            }}
        </button>

        <mat-menu #pmMenu="matMenu">
            <button (click)="onProjectManagerFilterChange(null)" mat-menu-item>Alle projectleiders</button>

            <button
                *ngFor="let pm of projectManagers; trackBy: trackByPmId"
                (click)="onProjectManagerFilterChange(pm.id)"
                mat-menu-item>
                {{ pm.name }}
            </button>
        </mat-menu>

        <div class="mt-3">Weergaveopties</div>
        <mat-selection-list (selectionChange)="onViewOptionsChange($event.options)" multiple>
            <mat-list-option [selected]="hideUnplannedExecutors$ | async" value="hideUnplanned"
                >Verberg ongeplande uitvoerders</mat-list-option
            >
            <mat-list-option [selected]="showFullYear$ | async" value="showFullYear">Toon jaar</mat-list-option>
            <mat-list-option [selected]="showPreviousWeeks$ | async" value="showPreviousWeeks"
                >Toon vorige 5 weken</mat-list-option
            >
            <mat-list-option [selected]="showProjectNumber$ | async" value="showProjectNumber"
                >Toon projectnummer</mat-list-option
            >
            <mat-list-option [selected]="allExecutorsExpandedState.checked" value="expandAll"
                >Uitgeklapt</mat-list-option
            >
        </mat-selection-list>
    </ng-container>
</app-page-header>

<div class="project-executor-planning">
    @if (executorSchedule$ | async; as executorScheduleArray) {
        @if (showHelp) {
            <div class="planning-instructions">
                <h3 class="planning-title">Hoe werkt de planning?</h3>

                <div class="planning-grid">
                    <div class="planning-item">
                        <strong class="planning-heading"> <i class="fas fa-mouse"></i> Linkermuisknop (Klik) </strong>
                        <div class="planning-content">
                            Geen planning → Nieuwe planning<br />
                            Met planning → Volgende activiteit
                        </div>
                    </div>

                    <div class="planning-item">
                        <strong class="planning-heading"> <i class="fas fa-keyboard"></i> CTRL + Klik </strong>
                        <div class="planning-content">
                            Geen planning → Vorige week kopiëren<br />
                            Met planning → Dag/Nacht wisselen
                        </div>
                    </div>

                    <div class="planning-item">
                        <strong class="planning-heading"> <i class="fas fa-arrows-alt"></i> SHIFT + Klik </strong>
                        <div class="planning-content">
                            Bulk planning kopiëren van eerste tot hier<br />
                            <span class="planning-note">(max 50 dagen, excl. weekends)</span>
                        </div>
                    </div>

                    <div class="planning-item">
                        <strong class="planning-heading"> <i class="fas fa-mouse"></i> Rechtermuisknop </strong>
                        <div class="planning-content">
                            Menu: Verwijderen, Verplaatsen,<br />
                            Kopiëren, Activiteit wijzigen
                        </div>
                    </div>
                </div>

                <div class="planning-tips">
                    <i class="fas fa-lightbulb"></i>
                    Klik op uitvoerdernaam om project toe te voegen • Dubbel klik op project om te wijzigen
                </div>
            </div>
        }

        <div class="planning-flex-wrapper">
            <div class="fixed-columns">
                @for (executorSchedule of executorScheduleArray; track trackByExecutorId($index, executorSchedule)) {
                    <div class="flex-header-row">
                        <div class="flex-header-cell executor-name" [class.clickable-executor]="!readonly">
                            <div class="executor-name-content">
                                <button
                                    class="collapse-button"
                                    [matTooltip]="executorSchedule.collapsed ? 'Uitklappen' : 'Inklappen'"
                                    (click)="toggleExecutorCollapse(executorSchedule.executor.id)">
                                    <mat-icon>{{
                                        executorSchedule.collapsed ? 'chevron_right' : 'expand_more'
                                    }}</mat-icon>
                                </button>
                                <span
                                    class="executor-name-text"
                                    [class.hide-after]="readonly"
                                    [matTooltip]="
                                        !readonly
                                            ? 'Klik om project toe te voegen aan ' + executorSchedule.executor.name
                                            : ''
                                    "
                                    (click)="onExecutorNameClick(executorSchedule.executor)">
                                    {{ executorSchedule.executor.name }}
                                </span>
                            </div>
                        </div>
                        <div class="flex-header-cell project-leader">Projectleider</div>
                    </div>
                    @if (!executorSchedule.collapsed) {
                        @for (
                            projectSchedule of executorSchedule.projects;
                            track trackByProjectId($index, projectSchedule)
                        ) {
                            <div class="flex-row">
                                <div
                                    class="flex-cell project-col clickable-project"
                                    [matTooltip]="projectSchedule.project.afas_project_id"
                                    (dblclick)="onProjectDoubleClick(projectSchedule.project)">
                                    @if (showProjectNumberSubject.value) {
                                        {{ projectSchedule.project.afas_project_id }}
                                    }
                                    {{ projectSchedule.project.name }}
                                </div>
                                <div class="flex-cell">
                                    {{ projectSchedule.project?.projectmanager?.firstname }}
                                    {{ projectSchedule.project?.projectmanager?.lastname | slice: 0 : 1 }}
                                </div>
                            </div>
                        }
                    }
                }
            </div>
            <div class="scrollable-weeks" #scrollableContainer>
                <div
                    class="planning-grid"
                    (click)="onCellClick($event)"
                    (dblclick)="onCellDblClick($event)"
                    (contextmenu)="onCellRightClick($event)">
                    @for (
                        executorSchedule of executorScheduleArray;
                        track trackByExecutorId($index, executorSchedule)
                    ) {
                        <div class="flex-header-row">
                            @for (week of visibleWeeks; track trackByWeek($index, week)) {
                                <div class="week-header" [matTooltip]="week | weekTooltip">
                                    <div class="week-header-content">
                                        <div class="week-number">Week {{ week.number }}</div>
                                        <div class="day-indicators">
                                            @for (date of week.dates; track date) {
                                                <div
                                                    class="day-indicator"
                                                    [ngClass]="{
                                                        'no-activity-day': !hasActivityForDay(date, executorSchedule),
                                                    }"></div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        @if (!executorSchedule.collapsed) {
                            @for (
                                projectSchedule of executorSchedule.projects;
                                track trackByProjectId($index, projectSchedule)
                            ) {
                                <div class="flex-row">
                                    @for (cell of projectSchedule.cells; track trackByCell($index, cell)) {
                                        <div
                                            class="flex-cell planning-day-cell"
                                            [class.clickable-cell]="!cell.hasAsphalt && !cell.isFrezenAsfalt"
                                            [ngClass]="cell.cssClasses"
                                            [attr.data-date]="cell.date"
                                            [attr.data-project-id]="projectSchedule.project.afas_project_id"
                                            [attr.data-executor-id]="executorSchedule.executor.id"
                                            [class.has-leave]="cell.hasLeave"
                                            [class.duplicate-cell]="cell.hasDuplicate"
                                            [class.asphalt-day-cell]="cell.hasAsphalt && !cell.hasDuplicate"
                                            [class.asphalt-active]="cell.hasAsphalt && !cell.hasDuplicate"
                                            [attr.title]="cell.title">
                                            @if (cell.hasDuplicate) {
                                                <span class="planning-cell">!</span>
                                            } @else if (cell.isFrezenAsfalt) {
                                                <span class="planning-cell frezen-asfalt">FA</span>
                                            } @else if (cell.hasEntry) {
                                                <span class="planning-cell" [ngClass]="cell.entry.activity">
                                                    {{ cell.entry.activity | activityLetter }}
                                                </span>
                                            } @else if (!cell.hasEntry && !cell.hasAsphalt) {
                                                &nbsp;
                                            }

                                            @if (
                                                cell.hasAsphalt &&
                                                !cell.hasDuplicate &&
                                                !cell.hasEntry &&
                                                !cell.isFrezenAsfalt
                                            ) {
                                                <span class="asphalt-indicator">{{ cell.asphaltIndicatorLetter }}</span>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        }
                    }
                </div>
            </div>
        </div>
    } @else if (isLoading()) {
        <div class="loading-container text-center p-4">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="mt-2">Planning laden...</p>
        </div>
    }
</div>

<button
    #planningContextMenuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="planningContextMenu"
    style="display: none"></button>

<mat-menu #planningContextMenu="matMenu">
    <div class="time-toggle-section">
        <div class="toggle-container">
            <mat-icon>wb_sunny</mat-icon>
            <mat-slide-toggle [checked]="contextMenuData.isNightMode" (change)="onTimeToggleChange($event)">
            </mat-slide-toggle>
            <span class="toggle-label">{{ contextMenuData.isNightMode ? 'Nacht (20:00)' : 'Dag (08:00)' }}</span>
        </div>
    </div>

    <button [matMenuTriggerFor]="activitySubmenu" mat-menu-item>
        <mat-icon>edit</mat-icon>
        <span>Activiteit wijzigen</span>
    </button>

    @if (contextMenuData.hasEntry) {
        <mat-divider></mat-divider>

        <button (click)="onContextMenuAction('delete')" mat-menu-item>
            <mat-icon>delete</mat-icon>
            <span>Verwijderen</span>
        </button>

        <button (click)="onContextMenuAction('delete_chain')" mat-menu-item>
            <mat-icon>delete</mat-icon>
            <span>Reeks verwijderen</span>
        </button>

        <button (click)="onContextMenuAction('delete_future')" mat-menu-item>
            <mat-icon>clear_all</mat-icon>
            <span>Verwijder toekomstige planning voor dit project</span>
        </button>

        <button (click)="onContextMenuAction('move_future')" mat-menu-item>
            <mat-icon>swap_horiz</mat-icon>
            <span>Verplaats toekomstige planning</span>
        </button>

        <button (click)="onContextMenuAction('copy_to_executor')" mat-menu-item>
            <mat-icon>content_copy</mat-icon>
            <span>Kopieer naar uitvoerder</span>
        </button>

        <button (click)="onContextMenuAction('shift_date_range')" mat-menu-item>
            <mat-icon>event_repeat</mat-icon>
            <span>Verplaatsen naar datum</span>
        </button>
    }
</mat-menu>

<mat-menu #activitySubmenu="matMenu">
    @for (activity of activities; track activity) {
        <button
            (click)="onContextMenuAction('add_activity', activity.value, null, contextMenuData.hasEntry)"
            mat-menu-item>
            <mat-icon>{{ activity.icon }}</mat-icon>
            <span>{{ activity.label }}</span>
        </button>
    }
</mat-menu>
